import React from "react";

export function Instagram(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.326 4c-2.261 0-2.545.01-3.433.05-.886.04-1.491.181-2.02.387a4.076 4.076 0 00-1.475.96 4.087 4.087 0 00-.961 1.475c-.207.53-.347 1.134-.387 2.02-.04.888-.05 1.172-.05 3.433 0 2.26.01 2.544.05 3.432.041.886.181 1.49.387 2.02a4.08 4.08 0 00.96 1.475c.463.463.927.748 1.474.96.53.207 1.135.347 2.021.387.888.04 1.172.05 3.433.05 2.26 0 2.543-.01 3.432-.05.886-.04 1.491-.18 2.021-.386a4.075 4.075 0 001.474-.961c.463-.463.747-.927.96-1.475.205-.53.346-1.134.387-2.02.04-.888.05-1.171.05-3.432s-.01-2.545-.05-3.433c-.041-.886-.182-1.49-.386-2.02a4.086 4.086 0 00-.961-1.475 4.07 4.07 0 00-1.474-.96c-.531-.206-1.136-.346-2.023-.387-.888-.04-1.17-.05-3.432-.05h.003zm-.747 1.5h.746c2.223 0 2.487.008 3.364.048.812.037 1.253.173 1.546.287.389.15.666.331.957.623.291.29.471.568.623.957.114.293.25.734.286 1.545.04.878.049 1.141.049 3.363s-.009 2.486-.049 3.363c-.037.812-.172 1.252-.286 1.545-.151.389-.332.665-.623.957a2.573 2.573 0 01-.957.622c-.293.115-.734.25-1.546.287-.877.04-1.14.049-3.364.049-2.223 0-2.486-.009-3.364-.049-.811-.037-1.252-.173-1.545-.287a2.578 2.578 0 01-.958-.622 2.58 2.58 0 01-.623-.957c-.114-.293-.25-.734-.286-1.546-.04-.877-.048-1.14-.048-3.364 0-2.223.008-2.485.048-3.363.037-.812.172-1.252.286-1.546a2.58 2.58 0 01.623-.957c.292-.291.57-.472.958-.623.293-.114.734-.25 1.545-.287.768-.035 1.066-.045 2.618-.047V5.5zm5.19 1.383a.999.999 0 100 1.998.999.999 0 000-1.999zM12.325 8.05a4.275 4.275 0 10.001 8.55 4.275 4.275 0 000-8.55zm0 1.5a2.775 2.775 0 110 5.55 2.775 2.775 0 010-5.55z"
        fill="#9F9F9F"
      />
    </svg>
  );
}

export function Facebook(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.27 20.982V12.49h2.343l.31-2.926H13.27l.004-1.465c0-.763.073-1.172 1.169-1.172h1.465V4h-2.344c-2.816 0-3.808 1.42-3.808 3.807v1.757H8v2.927h1.755v8.491h3.514z"
        fill="#9F9F9F"
      />
    </svg>
  );
}

export function Paw(props) {
  return (
    <svg
      width={34}
      height={34}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="#9F9F9F"
        d="M25.142 19.324C22.854 16.562 19.963 15.04 17 15.04c-2.963 0-5.854 1.52-8.142 4.283-2.056 2.482-3.283 5.611-3.283 8.37 0 1.34.41 2.36 1.217 3.033.797.664 1.85.889 3.024.889 1.25 0 2.637-.255 4-.505 1.192-.218 2.317-.425 3.184-.425.749 0 1.804.196 2.921.404 2.611.484 5.57 1.034 7.28-.388.813-.676 1.225-1.688 1.225-3.009 0-2.758-1.228-5.887-3.284-8.37zm.785 9.846c-.99.824-3.57.345-5.642-.04-1.21-.224-2.353-.436-3.285-.436-1.049 0-2.26.222-3.543.458-1.988.364-4.461.818-5.39.044-.124-.103-.5-.417-.5-1.503 0-2.274 1.082-4.994 2.825-7.099 1.902-2.296 4.25-3.561 6.608-3.561 2.359 0 4.705 1.265 6.608 3.561 1.743 2.105 2.825 4.825 2.825 7.1 0 1.056-.38 1.372-.506 1.476zM25.376 4.326c-.837-1.234-2.036-1.941-3.288-1.941-1.253 0-2.452.707-3.289 1.941-.768 1.134-1.192 2.622-1.192 4.192 0 1.57.423 3.058 1.192 4.192.837 1.234 2.036 1.942 3.289 1.942 1.252 0 2.45-.708 3.288-1.942.769-1.134 1.192-2.622 1.192-4.192 0-1.57-.423-3.058-1.192-4.192zm-1.649 7.266c-.27.399-.843 1.068-1.64 1.068-.796 0-1.369-.67-1.639-1.068-.54-.796-.849-1.916-.849-3.074s.31-2.278.849-3.074c.27-.398.843-1.067 1.64-1.067.796 0 1.369.669 1.64 1.067.539.796.848 1.916.848 3.074s-.31 2.278-.849 3.074zM15.2 4.326c-.836-1.234-2.035-1.942-3.287-1.942-1.253 0-2.452.708-3.289 1.942-.769 1.134-1.192 2.622-1.192 4.192 0 1.57.423 3.058 1.192 4.192.837 1.234 2.036 1.942 3.288 1.942 1.253 0 2.452-.708 3.289-1.942.769-1.134 1.192-2.623 1.192-4.192 0-1.57-.423-3.058-1.192-4.192zm-1.648 7.266c-.27.398-.843 1.067-1.64 1.067-.796 0-1.369-.669-1.64-1.067-.539-.796-.848-1.916-.848-3.074s.31-2.278.849-3.074c.27-.398.843-1.068 1.64-1.068.796 0 1.368.67 1.639 1.068.54.796.849 1.916.849 3.074s-.31 2.278-.85 3.074zM33.802 13.954c-.337-1.148-1.06-1.982-2.036-2.348-.785-.295-1.672-.245-2.496.14-1.136.532-2.064 1.63-2.547 3.012-.395 1.13-.444 2.323-.139 3.361.338 1.148 1.061 1.982 2.037 2.349.338.127.694.19 1.056.19.48 0 .97-.111 1.44-.331 1.135-.532 2.064-1.63 2.547-3.011.394-1.13.443-2.323.138-3.362zm-2.02 2.705c-.302.866-.866 1.563-1.51 1.864-.236.11-.593.214-.95.08-.863-.324-1.199-1.814-.719-3.188.303-.866.868-1.563 1.511-1.864.157-.073.367-.144.594-.144.116 0 .237.018.357.064.863.324 1.198 1.813.718 3.188zM7.277 14.758c-.483-1.382-1.411-2.48-2.547-3.011-.824-.386-1.71-.436-2.496-.141-.975.366-1.699 1.2-2.036 2.348-.305 1.038-.256 2.232.138 3.362.483 1.382 1.412 2.48 2.547 3.01.47.22.96.332 1.44.332.362 0 .719-.064 1.056-.19.976-.367 1.7-1.2 2.037-2.349.305-1.038.256-2.232-.139-3.361zM4.68 18.603c-.358.134-.715.03-.951-.08-.644-.302-1.208-.998-1.51-1.864-.481-1.374-.146-2.864.717-3.188.357-.134.714-.03.95.08.644.301 1.21.998 1.512 1.864.48 1.374.144 2.864-.718 3.188z"
      />
    </svg>
  );
}

export function Wallet(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        stroke="#9F9F9F"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M2.567 2.756l16.063 4.01c1.934.483 3.516 2.51 3.516 4.505v14.5c0 1.994-1.588 3.25-3.529 2.793l-13.484-3.17c-1.941-.458-3.529-2.463-3.529-4.456V5.229A3.635 3.635 0 015.23 1.604h20.542a3.635 3.635 0 013.625 3.625v13.292a3.636 3.636 0 01-3.625 3.625h-3.625M12.48 5.23h12.082" />
        <path d="M16.708 19.73a2.417 2.417 0 100-4.834 2.417 2.417 0 000 4.833zM22.146 11.27h2.416" />
      </g>
    </svg>
  );
}
